import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/SistemaContraIncendiosNormalizados/CarcasaPartida/CarcsaPartida1.png';
import Img2 from '../../img/products/SistemaContraIncendiosNormalizados/CarcasaPartida/CarcsaPartida2.png';

const BombasAutocebantes = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Sistema Contra Incendios - Carcasa Partida</h2>
      <div className="row align-items-start mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas contra incendio de carcasa partida, también conocidas como bombas de carcasa bipartida, 
            son un tipo de bomba centrífuga diseñada para aplicaciones de protección contra incendios. Estas 
            bombas son reconocidas por su alta eficiencia y durabilidad, y son ampliamente utilizadas en sistemas 
            de extinción de incendios adecuadas para una amplia gama de aplicaciones, desde edificios comerciales 
            y residenciales hasta instalaciones industriales y aeropuertos.
          </p>
          <p className="lead text-justify">
            La carcasa de la bomba está dividida axialmente, lo que facilita el acceso a los componentes internos 
            para mantenimiento y reparación sin necesidad de desmontar la bomba completa.
          </p>
          <p className="lead text-justify">
            El diseño de carcasa partida permite un acceso rápido y sencillo a los componentes internos, lo que 
            reduce el tiempo de inactividad durante el mantenimiento y las reparaciones.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="CarcasaPartida 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="CarcasaPartida 2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasAutocebantes;
